
import {LetterForm} from "./components/letter-form";

customElements.define("letter-form", LetterForm);
